import ReactGA from "react-ga4";
import { cme_kurs } from "./Kurs";

// -- init ga with tracking-id
const trackingId = process.env.REACT_APP_GA_TRACKING_CODE;
ReactGA.initialize(trackingId);


// -- only send ga-statistic from cmeassist
const host = window.location.host;
const GoggleAnalyticsActive = host.includes('cmeassist') ? true : false;
console.log('%cGoogleAnalytics active: ', 'color: #0044ff', GoggleAnalyticsActive);


// -- user view page for the first time
const sendPageView = () => {
    const sendThis = {
        "hitType": "pageview",
        "VNR": cme_kurs.VNR,
        "KursTitel": cme_kurs.KursTitel,
        "KursKey": cme_kurs.KursKey,
        "KursTyp": cme_kurs.KursTyp,
        "Sponsor": cme_kurs.Sponsor_Name
    }

    if (GoggleAnalyticsActive) ReactGA.send(sendThis)
}



// -- send something to google-analytics-4
const sendToGa4 = (eventName, eventParams) => {
    if (GoggleAnalyticsActive) {
        console.log(`Event "${eventName}": `, eventParams);
        ReactGA.event(eventName, eventParams)
    };
}



// -- progress steps for video-progression
const videoProgressSteps = [0, 5, 25, 50, 75, 95, 100];
const videoProgressEventName = 'video_fortschritt';
const videoProgressParam = 'video_progress';

// -- if video-progress changes -> sent to google-analytics
const videoProgressUpdate = (videoProgress, sentProgress, setSentProgress) => {
    var newSentProgress = { ...sentProgress };
    var changed = false;

    // run through progress-steps
    for (let i = 0; i < videoProgressSteps.length; i++) {
        const step = videoProgressSteps[i];
        const nextStep = videoProgressSteps[i + 1];

        // -- last step
        if (nextStep && !sentProgress[100] && nextStep === 100) {
            // send event to ga4
            sendToGa4(videoProgressEventName, { [videoProgressParam]: 100 });
            newSentProgress[100] = true;
            changed = true;
        }
        // -- step
        else if (nextStep && !sentProgress[step] && nextStep !== 100) {
            // send event to ga4
            sendToGa4(videoProgressEventName, { [videoProgressParam]: step });
            newSentProgress[step] = true;
            changed = true;
        }

        // -- stop
        if (step === videoProgress) break;
    }


    // update state which determins which progress-numbers got sent already
    // -- nur aktualisieren, wenn sich tatsächlich etwas geändert hat, um Endlosschleifen zu vermeiden
    if (changed) setSentProgress(newSentProgress);
}




export { sendPageView, sendToGa4, videoProgressSteps, videoProgressUpdate }